import { render, staticRenderFns } from "./transport_detail.vue?vue&type=template&id=4eb46c84&scoped=true&"
import script from "./transport_detail.vue?vue&type=script&lang=js&"
export * from "./transport_detail.vue?vue&type=script&lang=js&"
import style0 from "./transport_detail.vue?vue&type=style&index=0&id=4eb46c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb46c84",
  null
  
)

export default component.exports